
import './config.css';
import { useState, useEffect } from 'react';

import Header from '../../components/Header';
import Title from '../../components/Title';
import { FiMessageSquare, FiPlus, FiSearch, FiEdit2 } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';

import firebase from '../../services/firebaseConnection';
import Modal from '../../components/Modal';

const listRef = firebase.firestore().collection('config').orderBy('created', 'desc');

export default function Dashboard(){
  const [config, setConfig] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const [lastDocs, setLastDocs] = useState();

  const [showPostModal, setShowPostModal] = useState(false);
  const [detail, setDetail] = useState();

  useEffect(()=> {

    async function loadChamados(){
      await listRef.limit(5)
      .get()
      .then((snapshot) => {
        updateState(snapshot)
      })
      .catch((err)=>{
        console.log('Deu algum erro: ', err);
        setLoadingMore(false);
      })
  
      setLoading(false);
  
    }

    loadChamados();

    return () => {

    }
  }, []);



  async function updateState(snapshot){
    const isCollectionEmpty = snapshot.size === 0;

    if(!isCollectionEmpty){
      let lista = [];

      snapshot.forEach((doc)=>{
        lista.push({
          id: doc.id,
          nomeconfig: doc.data().nomeconfig,
          sloganconfig: doc.data().sloganconfig,
          desccurtaconfig: doc.data().desccurtaconfig,
          palavrachaveconfig: doc.data().palavrachaveconfig,
          razaoconfig: doc.data().razaoconfig,
          cnpjconfig: doc.data().cnpjconfig,
          cepconfig: doc.data().cepconfig,
          logradouroconfig: doc.data().logradouroconfig,
          numeroconfig: doc.data().numeroconfig,
          complementoconfig: doc.data().complementoconfig,
          bairroconfig: doc.data().bairroconfig,
          cidadeconfig: doc.data().cidadeconfig,
          estadoconfig: doc.data().estadoconfig,
          paisconfig: doc.data().paisconfig,
          siteconfig: doc.data().siteconfig,
          emailconfig: doc.data().emailconfig,
          linkinstagramconfig: doc.data().linkinstagramconfig,
          linkfbconfig: doc.data().linkfbconfig,
          linkyoutubeconfig: doc.data().linkyoutubeconfig,
          linkdriveconfig: doc.data().linkdriveconfig,
          linklinkedconfig: doc.data().linklinkedconfig,
          linkapplestoreconfig: doc.data().linkapplestoreconfig,
          linkgoogleplayconfig: doc.data().linkgoogleplayconfig,
          telefone1config: doc.data().telefone1config,
          telefone2config: doc.data().telefone2config,
          whats1config: doc.data().whats1config,
          whats2config: doc.data().whats2config,
          created: doc.data().created,
          createdFormated: format(doc.data().created.toDate(), 'dd/MM/yyyy')
        })
      })

      const lastDoc = snapshot.docs[snapshot.docs.length -1]; //Pegando o ultimo documento buscado
      
      setConfig(config => [...config, ...lista]);
      setLastDocs(lastDoc);

    }else{
      setIsEmpty(true);
    }

    setLoadingMore(false);

  }


  async function handleMore(){
    setLoadingMore(true);
    await listRef.startAfter(lastDocs).limit(5)
    .get()
    .then((snapshot)=>{
      updateState(snapshot)
    })
  }


  function togglePostModal(item){
    setShowPostModal(!showPostModal) //trocando de true pra false
    setDetail(item);
  }
 

  if(loading){
    return(
      <div>
        <Header/>

        <div className="content">
          <Title name="Config">
            <FiMessageSquare size={25} />
          </Title>  

          <div className="container dashboard">
            <span>Buscando Config...</span>
          </div>

        </div>      
      </div>
    )
  }

  return(
    <div>
      <Header/>

      <div className="content">
        <Title name="Config">
          <FiMessageSquare size={25} />
        </Title>

        {config.length === 0 ? (
          <div className="container dashboard">
            <span>Nenhum configuração registrada...</span>

            <Link to="/config" className="new">
              <FiPlus size={25} color="#FFF" />
              Nova Configuração
            </Link>
          </div>
        )  : (
          <>

            <table>
              <thead>
                <tr>
                  <th scope="col">Configuração</th>

                  <th scope="col">Cadastrado em</th>
                  <th scope="col">#</th>
                </tr>
              </thead>
              <tbody>
                {config.map((item, index)=>{
                  return(
                    <tr key={index}>
                      <td data-label="Configuração">{item.nomeconfig}</td>
                      <td data-label="Cadastrado">{item.createdFormated}</td>
                      <td data-label="#">
                        <button className="action" style={{backgroundColor: '#3583f6' }} onClick={ () => togglePostModal(item) }>
                          <FiSearch color="#FFF" size={17} />
                        </button>
                        <Link className="action" style={{backgroundColor: '#F6a935' }} to={`/config/${item.id}`} >
                          <FiEdit2 color="#FFF" size={17} />
                        </Link>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            
            {loadingMore && <h3 style={{textAlign: 'center', marginTop: 15 }}>Buscando dados...</h3>}
            { !loadingMore && !isEmpty && <button className="btn-more" onClick={handleMore}>Buscar mais</button> }

          </>
        )}

      </div>

      {showPostModal && (
        <Modal
          conteudo={detail}
          close={togglePostModal}
        />
      )}

    </div>
  )
}